import { apiClient } from './client';
import type { ApiResponse } from '@/types/api';

export interface DashboardStats {
  totalUsers: {
    value: number;
    change: string;
    changeType: 'positive' | 'negative';
  };
  monthlyPayments: {
    value: number;
    change: string;
    changeType: 'positive' | 'negative';
  };
  totalRiskAssessments: {
    value: number;
    change: string;
    changeType: 'positive' | 'negative';
  };
  monthlyGrowthRate: {
    value: string;
    change: string;
    changeType: 'positive' | 'negative';
  };
}

export interface RecentUser {
  id: number;
  email: string;
  company?: string;
  createdAt: string;
  timeAgo: string;
}

export interface RecentPayment {
  id: number;
  finalAmount: number;
  planName: string;
  userEmail: string;
  createdAt: string;
  timeAgo: string;
}

class DashboardService {
  async getDashboardStats(): Promise<ApiResponse<DashboardStats>> {
    return apiClient.get('/admin/dashboard/stats');
  }

  async getRecentUsers(): Promise<ApiResponse<RecentUser[]>> {
    return apiClient.get('/admin/dashboard/recent-users');
  }

  async getRecentPayments(): Promise<ApiResponse<RecentPayment[]>> {
    return apiClient.get('/admin/dashboard/recent-payments');
  }
}

export const dashboardService = new DashboardService();
